import {
  EmpleadoAdminResponse,
  EmpleadoDetalle,
  EmpleadoFiltro,
  EmpleadoRequest,
  EmpleadoSearchResult,
  EmpleadoUenFiltro,
} from '../../model/empleado/empleado';

/**
 * Puerto Abstracto: EmpleadoRepository
 *
 * Define el contrato para búsqueda, detalle, creación y modificación de
 * empleados (asesores) — HU1259115 "Administrar Empleados/Asesores".
 *
 * Legacy Reference:
 * - SearchersHandler.searchAdvisors()
 * - AsesorSearchActivity → COMMAND_SEARCH_ADVISORS
 * - AdminEmpleadosActivity → CrearEmpleadoViewImpl / ModificarEmpleadoViewImpl
 * - Busca en TPSC_EMPLEADOS (no en TPSC_PERSONAS)
 */
export abstract class EmpleadoRepository {

  /**
   * Busca empleados (asesores) con filtros por identificación.
   * Replica el buscador de asesores del legacy.
   */
  abstract buscar(filtro: EmpleadoFiltro, size: number, cursor?: string, direction?: string): Promise<EmpleadoSearchResult>;

  /**
   * Busca empleados por Unidad Estratégica de Negocio (UEN) — segundo modo
   * de búsqueda del listado de "Administrar Empleados" (RN-01).
   */
  abstract buscarPorUen(filtro: EmpleadoUenFiltro, size: number, cursor?: string, direction?: string): Promise<EmpleadoSearchResult>;

  /**
   * Obtiene el detalle completo de un empleado para precargar el formulario
   * de Modificar. Retorna `null` si no existe (404).
   */
  abstract obtenerDetalle(id: number): Promise<EmpleadoDetalle | null>;

  /** Crea un nuevo empleado/asesor. */
  abstract crear(request: EmpleadoRequest): Promise<EmpleadoAdminResponse>;

  /** Modifica un empleado/asesor existente. */
  abstract actualizar(id: number, request: EmpleadoRequest): Promise<EmpleadoAdminResponse>;

  /**
   * Obtiene la foto de un empleado como Blob, o `null` si no tiene foto
   * almacenada (404). Legacy: `RecuperarFotoEmpleadoServlet`.
   */
  abstract obtenerFoto(id: number): Promise<Blob | null>;
}
